module.exports = __webpack_public_path__ + "media/images/icons/outlined/monitor-2972ee3afd950dbae82b08689619d964.svg";